module.exports = __webpack_public_path__ + "img/mortgages.a7ce5b9.svg";